import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-global-inner-banner',
  templateUrl: './global-inner-banner.component.html',
  styleUrls: ['./global-inner-banner.component.scss']
})
export class GlobalInnerBannerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
